<template>
  <div id="next-event-widget">
    <default-next-events-widget
      :limitEvent="limitEvent"
      :page="page"
      :closable="closable"
      :controlPagination="controlPagination"
      v-if="getGameConsole === 'default'"
    ></default-next-events-widget>
    <market-view-next-events-widget
      :limitEvent="limitEvent"
      :page="page"
      :closable="closable"
      v-if="getGameConsole === 'marketview'"
    ></market-view-next-events-widget>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'

const DefaultNextEventsWidget = () => ({
  component: import(
    '@/components/center_widgets/Previews/DefaultNextEventsWidget'
  ),
  loading: LoadingSkeleton,
  timeout: 200,
})

const MarketViewNextEventsWidget = () => ({
  component: import(
    '@/components/center_widgets/Previews/MarketViewNextEventsWidget'
  ),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'NextEventWidget',
  props: {
    limitEvent: {
      type: Number,
      default: 15,
    },
    page: {
      type: Number,
      default: 1,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    controlPagination: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DefaultNextEventsWidget,
    MarketViewNextEventsWidget,
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      getGameConsole: 'settings/getGameConsole',
    }),
  },
}
</script>

<style></style>
